<template>
  <div>
    <b-card :title="cardTitle">
      <b-row class="d-flex justify-content-center align-items-center">
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Yıl"
            label-for="year"
          >
            <v-select
              id="year"
              v-model="filterParams.year"
              label="title"
              :reduce="item => item"
              :options="filterItems.years"
              placeholder="Yıl"
              :clearable="false"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Departman"
            label-for="id_com_department"
          >
            <v-select
              id="year"
              v-model="filterParams.id_com_department"
              label="title"
              :reduce="item => item.id"
              :options="filterItems.departments"
              placeholder="Departman"
              :clearable="false"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Marka"
            label-for="id_com_brand"
          >
            <v-select
              id="year"
              v-model="filterParams.id_com_brand"
              label="title"
              :reduce="item => item.id"
              :options="filterItems.brands"
              placeholder="Marka"
              :clearable="false"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Lokasyon"
            label-for="id_com_locations"
          >
            <v-select
              id="year"
              v-model="filterParams.id_com_location"
              label="title"
              :reduce="item => item.id"
              :options="filterItems.locations"
              placeholder="Lokasyon"
              :clearable="false"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="text-center"
        >
          <b-button
            variant="primary"
            :disabled="!filterParams.year || !filterParams.id_com_department || !filterParams.id_com_brand || !filterParams.id_com_location"
            @click="getReportData"
          >
            <FeatherIcon icon="FilterIcon" />
            Raporu Görüntüle
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BCol, BFormGroup, BRow, BCard, BButton,
} from 'bootstrap-vue'

export default {
  name: 'CsiFilter',
  components: {
    BFormGroup,
    BCol,
    BRow,
    BCard,
    vSelect,
    BButton,
  },
  props: {
    cardTitle: {
      type: String,
      default: null,
    },
    getReportData: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterItems() {
      return this.$store.getters['crmCsiReports/filterItems']
    },
    filterParams() {
      return this.$store.getters['crmCsiReports/filterParams']
    },
  },
}
</script>
